import React, { Fragment } from 'react';
import {
  string,
  shape,
  bool,
  func,
} from 'prop-types';
import classNames from 'classnames';

import {
  Button, Heading, Paragraph, Small,
} from 'components/common';
import { onCtaClick } from 'helpers/Utils';

import './StickyCTABanner.scss';

const StickyCTABanner = ({
  ctaButton,
  image,
  name,
  hidden,
  onCtaLinkClick,
  upperShortDescription,
}) => {
  const {
    label,
    link,
    shortDescription,
  } = ctaButton;

  return (
    <div className={classNames(['cta-banner', { hidden }])}>
      <div className="cta-content">
        <div className="product-description">
          <div className="product-image">
            <img src={image.url} alt={image.alt} />
          </div>
          <div className="product-titles">
            <div className="product-name-desktop">
              {upperShortDescription && (<div>{upperShortDescription}</div>)}
              <Heading as="h2">
                {name}
              </Heading>
            </div>
            <div className="product-name-mobile">
              {upperShortDescription && (<div>{upperShortDescription}</div>)}
              <Paragraph>
                <strong>
                  {name}
                </strong>
              </Paragraph>
            </div>
            {shortDescription && (
              <Fragment>
                <div className="product-promo-desktop">
                  <Paragraph secondary>
                    {shortDescription}
                  </Paragraph>
                </div>
                <div className="product-promo-mobile">
                  <Small secondary>
                    {shortDescription}
                  </Small>
                </div>
              </Fragment>
            )}
          </div>
        </div>
        {ctaButton && ctaButton.show && (
          <div className="cta-button">
            <Button
              className="cta-btn-apply"
              primary
              onClick={onCtaClick({ show: true, link }, onCtaLinkClick)}
            >
              {label}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

StickyCTABanner.propTypes = {
  image: shape({
    url: string.isRequired,
    alt: string,
  }).isRequired,
  name: string.isRequired,
  hidden: bool,
  ctaButton: shape({
    link: shape({}),
    label: string,
    shortDescription: string,
  }),
  onCtaLinkClick: func,
  upperShortDescription: string,
};

StickyCTABanner.defaultProps = {
  hidden: true,
  ctaButton: {},
  onCtaLinkClick: null,
};

export default StickyCTABanner;
